import { useEffect, useState, useRef, useCallback, useMemo } from "react";
import {
  UPDATE_PROPERTY_BY_CLIENT_ID,
  // POST_PROPERTY_FLOOR_IAMGE,
  POST_PROPERTY_COMPLIANCE_DOCS,
  GET_FLOOR_DETAILS_BY_PROPERTY_CLIENT,
  DELETE_COMPLIANCE_DOC,
  DELETE_FLOOR_PLAN_IMAGE,
  UPLOAD_PROPERTY_UPDATE_IMAGE,
  GET_BLOCK_DATA,
  DELETE_BLOCK_DOCUMENT,
  UPDATE_BLOCKS_DATA,
  CHECK_COMPANY_CLIENTNAME,
  SELECT_CLIENT,
  DELETE_BLOCK_DATA,
  // DELETE_IMAGE_API,
} from "../api/apiPath";
import { hostName } from "../config/config";
import http from "../api/server";
import { useSelector } from "react-redux";
import FileUpload from "./common/FileUpload";
// import { IconButton } from "@mui/material";
// import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import { generatePath, useParams } from "react-router-dom";

import AutocompleteInput from "./common/AutocompleteInput";
import delicon from "../assets/img/del.png";

import Select from "react-select";
import ConfirmationPopup from "./common/ConfirmationPopup";
import LoadingComponent from "./common/LoadingComponent";
import useGetClientId from "../hooks/useGetClientId";
const UpdateProperty = (props) => {
  const {
    clientId,
    editPropertyDetails,
    // blocksList,
    setRenderUpdateProperty,
    handleGetAllPropertyByClinetID,
    cityList,
    inspectorList,
    approverList,
    setToastData,
  } = props;
  const { clientNameParam } = useParams();
  //const [propertyCity, setPropertyCity] = useState(editPropertyDetails?.city);
  const [savedFloorImages, setSavedFloorImages] = useState(null);
  const [savedCompDocs, setSavedCompDocs] = useState(null);
  // const [floorError, setFloorError] = useState("");
  const [showConfirmationPopup, setShowConfirmationPopup] = useState({
    show: false,
    headingText: "",
    infoText: "",
    cancelText: "",
    submittext: "",
  });
  const [activeTab, setActiveTab] = useState("Site"); //or Block
  const [showNewCityInput, setShowNewCityInput] = useState(false);
  const [newCityName, setNewCityName] = useState("");
  const [cityError, setCityError] = useState("");
  const [isCityTyping, setIsCityTyping] = useState(false);

  const handleTabChange = (e) => {
    setActiveTab(e);
    setValidationFlag(false);
  };
  const [loading, setLoading] = useState(false);
  const [floorNumberToDelete, setFloorNumberToDelete] = useState(null);
  // console.log("editpr", editPropertyDetails);
  //eslint-disable-next-line no-unused-vars
  const [loadExistingFile, setLoadExistingFile] = useState(
    editPropertyDetails?.propertyImage === null ||
      editPropertyDetails?.propertyImage === ""
      ? true
      : false,
  );
  const { userObj } = useSelector((state) => state.user);
  const ImageProxyBaseUrl = hostName + "/api/Inspection/api/image?blobUrl=";
  // const editPropertyBlockObj = {
  //   blockId:
  //     editPropertyDetails?.blockId === "00000000-0000-0000-0000-000000000000"
  //       ? null
  //       : editPropertyDetails?.blockId,
  //   blockName: editPropertyDetails?.blockName,
  // };
  const [propertyName, setPropertyName] = useState(
    editPropertyDetails?.propertyName,
  );
  const [propertyAddress, setPropertyAddress] = useState(
    editPropertyDetails?.propertyLocation,
  );
  const [propertyPostalCode, setPropertyPostalCode] = useState(
    editPropertyDetails?.postalCode,
  );
  // const [propertyTotalFloor, setPropertyTotalFloor] = useState(
  //   editPropertyDetails?.totalNoOfFloors
  // );
  const [siteLatitude, setSiteLatitude] = useState(editPropertyDetails?.lat);
  const [siteLongitude, setSiteLongitude] = useState(editPropertyDetails?.long);
  const [numberofBlocks, setNumberofBlocks] = useState(
    editPropertyDetails?.numberOfBlocks,
  );
  const [blockData, setBlockData] = useState([]);
  const [blockDataArchive, setBlockDataArchive] = useState([]);
  const [blockOrder, setBlockOrder] = useState([]);
  const [blockToDelete, setBlockToDelete] = useState({});

  // const [showFloorImages, setShowFloorImages] = useState(
  //   editPropertyDetails?.totalNoOfFloors === null ||
  //     editPropertyDetails?.totalNoOfFloors === "0" ||
  //     editPropertyDetails?.totalNoOfFloors === 0
  //     ? false
  //     : true
  // );
  const editPropertyCityObj = {
    cityId: Number(editPropertyDetails?.cityId),
    cityName: cityList?.find(
      (city) => city.cityId.toString() === editPropertyDetails?.cityId,
    )?.cityName,
  };
  const [propertyCity, setPropertyCity] = useState(editPropertyCityObj);
  const [propertyStatus, setPropertyStatus] = useState(
    editPropertyDetails?.propertyStatus,
  );
  const [propertyImage, setPropertyImage] = useState(
    editPropertyDetails?.propertyImage,
  );
  // const [propertyBlockObj, setPropertyBlockName] =
  //   useState(editPropertyBlockObj);

  const [files, setFiles] = useState([]);
  const [validationFlag, setValidationFlag] = useState(false);

  // const [floorEntries, setFloorEntries] = useState([]);

  const [propertyInspector, setPropertyInspector] = useState(
    editPropertyDetails?.inspectors.map((inspector) => ({
      value: inspector.userId,
      label: inspector.userName ? inspector.userName : inspector.fullName,
    })),
  );
  const [propertyApprover, setPropertyApprover] = useState(
    editPropertyDetails?.approvers.map((approver) => ({
      value: approver.userId,
      label: approver.userName ? approver.userName : approver.fullName,
    })),
  );

  // Client selection states
  const clientObj = useGetClientId();
  const [clientsList, setClientsList] = useState([]);
  const [selectedClient, setSelectedClient] = useState(
    editPropertyDetails?.companyClientMappingId || "",
  );
  const [selectedClientName, setSelectedClientName] = useState(
    editPropertyDetails?.companyClientName || "",
  );
  const [showNewClientInput, setShowNewClientInput] = useState(false);
  const [newClientName, setNewClientName] = useState("");
  const [clientError, setClientError] = useState("");
  const [isClientFieldEnabled, setIsClientFieldEnabled] = useState(true);
  const clientRef = useRef(null);

  const editPropertyFloorDetails = async () => {
    try {
      const response = await http.get(
        hostName +
          GET_FLOOR_DETAILS_BY_PROPERTY_CLIENT +
          `?propertyId=${editPropertyDetails?.propertyMasterId}&clientId=${clientId}`,
      );
      if (response.status === 200) {
        console.log("floor details", response?.data);
        setSavedFloorImages(response?.data?.floorDetails || []);
        setSavedCompDocs(response?.data?.complianceDocFiles || []);

        // Set client information from API response
        if (response?.data?.companyClientMappingId) {
          setSelectedClient(response.data.companyClientMappingId);
        }
        if (response?.data?.companyClientName) {
          setSelectedClientName(response.data.companyClientName);
        }
      }
    } catch (error) {
      return {};
    }
  };

  const getBlockDetails = async () => {
    setLoading(true);
    try {
      const response = await http.get(
        GET_BLOCK_DATA +
          `?PropertyMasterId=${editPropertyDetails?.propertyMasterId}&ClientId=${clientId}`,
      );
      if (response.status === 200) {
        console.log("block deets", response, blockData);
        const data = response?.data;
        const blockArr = data?.map((block, index) => {
          const isBuildingPdf = block?.buildingPdf;
          const isBuildingImage = block?.buildingImage;
          let pdfurl;
          if (isBuildingPdf) {
            const blob = base64ToBlob(block?.buildingPdf, "application/pdf");
            pdfurl = URL.createObjectURL(blob);
          }
          return {
            id: index + 1,
            blockId: block.blockId,
            isSavedBlockData: true,
            blockName: block.blockName,
            totalFloors: block.totalFloors,
            showFloorImages: false,
            savedfloorArray: (block?.floorPlans ?? []).map((floor) => ({
              blockFloorId: floor.blockFloorPlanDetailsId,
              floor: floor.floorNumber,
              image: floor.floorPlanImage,
              floorError: "",
            })),
            buildingImage: null,
            bluildingBlobUrl: block?.buildingImage,
            previewBuildingImage: isBuildingPdf
              ? pdfurl
              : isBuildingImage
                ? ImageProxyBaseUrl + block?.buildingImage
                : null,
            buildingNotSaved: false,
            buildingImageType: isBuildingPdf
              ? "application/pdf"
              : isBuildingImage
                ? "image/*"
                : null,
            buildingFileName: block?.buildingFileName || null,
            floorArray: Array.from(
              { length: Number(block.totalFloors || 0) },
              (_, i) => {
                const floorNo = i + 1;
                const existing = (block.floorPlans ?? []).find(
                  (f) => f.floorNumber === floorNo,
                );
                let pdfUrl;
                if (existing?.floorPlanPdf) {
                  const blob = base64ToBlob(
                    existing?.floorPlanPdf,
                    "application/pdf",
                  );
                  pdfUrl = URL.createObjectURL(blob);
                }

                return {
                  blockId: block.blockId,
                  blockFloorId: existing?.blockFloorPlanDetailsId ?? null,
                  floor: floorNo,
                  image: existing?.floorPlanImage ?? null,
                  loadedImage:
                    !!existing?.floorPlanImage || !!existing?.floorPlanPdf, // to track if there's an existing image or pdf
                  floorError: "",
                  floorPdfUrl: pdfUrl || null,
                  floorPdfName: existing?.floorPlanFileName || null,
                  floorBlobUrl: existing?.floorPlanImage,
                  floorNotSaved: false,
                };
              },
            ),

            savedadditionalDocsArr: (
              block?.documents ??
              block?.Documents ??
              block?.Document ??
              []
            ).map((doc) => ({
              docId: doc.fileId,
              complianceType: doc.documentType,
              complianceFileName: doc.documentFileName,
              file: doc.documentFileUrl,
            })),
            additionalDocsArr: [],
            fileError: "",
            fileShowValidation: false,
            formErrors: {}, // add these
            hasFormErrors: false,
          };
        });
        console.log("block arr", blockArr);
        setBlockOrder(blockArr.map((b) => b.blockId) ?? []);
        setBlockData(blockArr);
        setBlockDataArchive(blockArr);
      }
    } catch (error) {
      return {};
    }finally{
      setLoading(false);
    }
  };

  const base64ToBlob = (base64, contentType = "application/pdf") => {
    const byteCharacters = atob(base64);
    const byteNumbers = new Array(byteCharacters.length);

    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }

    const byteArray = new Uint8Array(byteNumbers);
    return new Blob([byteArray], { type: contentType });
  };

  //inputrefs
  const inputRefs = {
    block: useRef([]),
    propertyName: useRef(null),
    propertyAddress: useRef(null),
    postalCode: useRef(null),
    // totalFloor: useRef(null),
    city: useRef(null),
    inspectors: useRef(null),
    approvers: useRef(null),
    floorImages: useRef(null),
  };
  //errorObject for form validation
  const [errorObject, setErrorObject] = useState({
    // block: "",
    propertyName: "",
    propertyAddress: "",
    postalCode: "",
    city: "",
    inspectors: "",
    approvers: "",
    fileError: "",
  });

  const ukPostcodeRegex = /^([A-Z]{1,2}\d[A-Z\d]? ?\d[A-Z]{2})$/i;

  const isValidUKLatitude = (lat) => {
    const num = Number(lat);
    return !Number.isNaN(num) && num >= 49.5 && num <= 61;
  };

  const isValidUKLongitude = (lng) => {
    const num = Number(lng);
    return !Number.isNaN(num) && num >= -8 && num <= 2;
  };

  const checkCompanyClient = async () => {
    if ((!selectedClient || selectedClient === "") && !newClientName.trim()) {
      return true;
    }
    const params = new URLSearchParams();
    params.append("clientId", clientObj?.clientId);
    params.append("companyClientName", newClientName);
    const queryString = params.toString();
    try {
      const response = await http.get(
        CHECK_COMPANY_CLIENTNAME + `?${queryString}`,
      );
      if (response.status === 200) {
        console.log("res", response);
        return response?.data;
      }
    } catch (err) {
      console.log("err in client name check", err);
    }
  };

  const validate = () => {
    const newErrors = {};
    // if (!propertyBlockObj?.blockName) newErrors.block = "Select Block";
    if (!propertyName) newErrors.propertyName = "Site Name is required";
    if (!propertyAddress)
      newErrors.propertyAddress = "Site Address is required";
    if (!propertyPostalCode) {
      newErrors.postalCode = "Postal Code is required";
    } else if (!ukPostcodeRegex.test(propertyPostalCode.trim())) {
      newErrors.postalCode = "Invalid UK Postal Code";
    }
    if (!numberofBlocks || numberofBlocks == 0) {
      newErrors.numberofBlocks = "At least 1 building required";
    }
    if (siteLatitude && !isValidUKLatitude(siteLatitude)) {
      newErrors.siteLatitude = "Enter valid UK Latitude";
    }
    if (siteLongitude && !isValidUKLongitude(siteLongitude)) {
      newErrors.siteLongitude = "Enter valid UK Longitude";
    }
    // if (!propertyCity?.cityName) newErrors.city = "Select City";
    if (!propertyCity?.cityId) {
      newErrors.city = "Select City";
    } else if (propertyCity.cityId === "add-new" && !newCityName.trim()) {
      newErrors.city = "Enter new city name";
    }
    if (propertyInspector && propertyInspector.length === 0)
      newErrors.inspectors = "Select at least one inspector";
    if (propertyApprover && propertyApprover.length === 0)
      newErrors.approvers = "Select at least one approver";

    for (const fe of files) {
      if (!fe.docName.trim()) {
        setError("Each file must have a document name.");
        setShowValidation(true);
        newErrors.fileError = "error in file data uploaded";
        break;
      }
      if (!fe.type) {
        setError("Each file must have a type selected.");
        setShowValidation(true);
        newErrors.fileError = "error in file data uploaded";
        break;
      }
      if (fe.file && fe.file.size > 10 * 1024 * 1024) {
        setError("Each file should not exceed 10 MB");
        setShowValidation(true);
        newErrors.fileError = "error in file data uploaded";
        break;
      }
    }

    if (!blockData || blockData.length === 0) {
      newErrors.buildingRequired = "At least 1 building required";
    }

    const blockFileErrors = blockData.some((block, blockIndex) => {
      let hasFileError = false;

      for (const file of block.additionalDocsArr) {
        if (!file.docName.trim()) {
          handleBlockDataChange(
            blockIndex,
            "fileError",
            "Each file must have a document name.",
          );
          handleBlockDataChange(blockIndex, "fileShowValidation", true);
          hasFileError = true;
          break;
        }
        if (!file.type) {
          handleBlockDataChange(
            blockIndex,
            "fileError",
            "Each file must have a type selected.",
          );
          handleBlockDataChange(blockIndex, "fileShowValidation", true);
          hasFileError = true;
          break;
        }
        if (file.file && file.file.size > 10 * 1024 * 1024) {
          handleBlockDataChange(
            blockIndex,
            "fileError",
            "Each file must not exceed 10 MB.",
          );
          handleBlockDataChange(blockIndex, "fileShowValidation", true);
          hasFileError = true;
          break;
        }
      }

      if (!hasFileError && block.additionalDocsArr.length > 0) {
        handleBlockDataChange(blockIndex, "fileError", "");
        handleBlockDataChange(blockIndex, "fileShowValidation", false);
      }

      return hasFileError;
    });

    if (blockFileErrors) {
      newErrors.blockFileError = "error in block file data uploaded";
    }

    const isPositiveInt = (n) => Number.isInteger(n) && n > 0 && n <= 200;

    const invalids = blockData
      .map((b, i) => ({
        index: i,
        id: b.id,
        blockNameEmpty: !String(b.blockName || "").trim(),
        totalFloorsInvalid: !isPositiveInt(Number(b.totalFloors)),
      }))
      .filter((x) => x.blockNameEmpty || x.totalFloorsInvalid);

    // Floor plan image is non-mandatory on update; only block name and total floors are validated here
    if (invalids.length > 0) {
      newErrors.blockData = "error in block data";
      setBlockData((prev) =>
        prev.map((b) => {
          const nameEmpty = !String(b.blockName || "").trim();
          const floorsInvalid =
            !Number.isInteger(Number(b.totalFloors)) ||
            Number(b.totalFloors) <= 0;

          const nextFloors = b.floorArray.map((f) => ({
            ...f,
            floorError: "", // Floor image is optional
          }));

          return {
            ...b,
            formErrors: {
              ...b.formErrors,
              blockName: nameEmpty ? "Block name is required" : "",
              totalFloors: floorsInvalid
                ? "Total floors must be a positive integer between 1 - 200"
                : "",
            },
            hasFormErrors: nameEmpty || floorsInvalid,
            floorArray: nextFloors,
          };
        }),
      );
      setBlockDataArchive((prev) =>
        prev.map((b) => {
          const nameEmpty = !String(b.blockName || "").trim();
          const floorsInvalid =
            !Number.isInteger(Number(b.totalFloors)) ||
            Number(b.totalFloors) <= 0;

          const nextFloors = b.floorArray.map((f) => ({
            ...f,
            floorError: "", // Floor image is optional
          }));

          return {
            ...b,
            formErrors: {
              ...b.formErrors,
              blockName: nameEmpty ? "Block name is required" : "",
              totalFloors: floorsInvalid
                ? "Total floors must be a positive integer between 1 - 200"
                : "",
            },
            hasFormErrors: nameEmpty || floorsInvalid,
            floorArray: nextFloors,
          };
        }),
      );
    }

    return newErrors;
  };

  // const validateFloorEntries = (cleanedFloor) => {
  //   const isEmptyFloorEntries = checkFloorEntries(floorEntries);
  //   const newFloorEntries = [...cleanedFloor];
  //   if (floorEntries.length > 0 && !isEmptyFloorEntries) {
  //     newFloorEntries.forEach((entry) => {
  //       if (entry.floor !== "Select" && entry.floor !== "" && !entry.image)
  //         entry.requireImage = "Please upload floor plan image";
  //       if (entry.image && (!entry.floor || entry.floor === "Select"))
  //         entry.requireFloor = "Please select floor";
  //     });
  //   }
  //   return newFloorEntries;
  // };

  // Fetch company clients list
  const getCompanyClients = async () => {
    try {
      const res = await http.get(
        `${SELECT_CLIENT}?clientId=${clientId || clientObj?.clientId}`,
      );

      if (res.status === 200) {
        setClientsList(res.data || []);
      }
    } catch (err) {
      console.error("Failed to fetch company clients", err);
    }
  };

  useEffect(() => {
    if (clientId || clientObj?.clientId) {
      getCompanyClients();
    }
  }, [clientId, clientObj?.clientId]);

  // Update selected client name when clients list is loaded and selectedClient is set
  useEffect(() => {
    if (selectedClient && clientsList.length > 0 && !showNewClientInput) {
      const client = clientsList.find(
        (c) => c.companyClientMappingId === selectedClient,
      );
      if (client) {
        setSelectedClientName(client.companyClientName);
      }
    } else if (selectedClient === "" || showNewClientInput) {
      setSelectedClientName("");
    }
  }, [selectedClient, clientsList, showNewClientInput]);

  // When selectedClient is cleared, show dropdown again
  useEffect(() => {
    if (selectedClient === "") {
      setShowNewClientInput(false);
      setNewClientName("");
    }
  }, [selectedClient]);

  useEffect(() => {
    editPropertyFloorDetails();
    getBlockDetails();
  }, [editPropertyDetails]);

  useEffect(() => {
    if (!files || files.length === 0) return;

    const hasError = files.some(
      (f) =>
        !f.docName?.trim() ||
        !f.type ||
        (f.file && f.file.size > 10 * 1024 * 1024),
    );

    if (!hasError) {
      setError("");
      setShowValidation(false);
    }
  }, [files]);
  useEffect(() => {
    if (!blockData || blockData.length === 0) return;

    setBlockData((prev) =>
      prev.map((block) => {
        if (!block.additionalDocsArr || block.additionalDocsArr.length === 0) {
          return {
            ...block,
            fileError: "",
            fileShowValidation: false,
          };
        }

        const hasError = block.additionalDocsArr.some(
          (f) =>
            !f.docName?.trim() ||
            !f.type ||
            (f.file && f.file.size > 10 * 1024 * 1024),
        );

        if (!hasError) {
          return {
            ...block,
            fileError: "",
            fileShowValidation: false,
          };
        }

        return block;
      }),
    );
  }, [blockData]);

  const cityOptions = useMemo(() => {
    const sortedCities = [...(cityList || [])].sort((a, b) =>
      (a.cityName || "").localeCompare(b.cityName || "", undefined, {
        sensitivity: "base",
      }),
    );

    return [{ cityId: "add-new", cityName: "➕ Others " }, ...sortedCities];
  }, [cityList]);
  //eslint-disable-next-line no-unused-vars
  const handleFileChange = (event) => {
    const file = event.target.files[0];
    setPropertyImage(file);
  };

  const [error, setError] = useState("");
  const [showValidation, setShowValidation] = useState(false);

  const uploadComplianceDocs = async (files) => {
    console.log("files", files);
    setLoading(true);
    const formDataToUploadCompliance = new FormData();
    formDataToUploadCompliance.append(
      "PropertyId",
      editPropertyDetails?.propertyMasterId,
    );
    formDataToUploadCompliance.append("ClientId", clientId);
    console.log("formDataToUploadCompliance", files);
    files?.forEach((fileObj, index) => {
      formDataToUploadCompliance.append(
        `complianceDocUploadDtos[${index}].complianceType`,
        fileObj.type || 0,
      );
      formDataToUploadCompliance.append(
        `complianceDocUploadDtos[${index}].complianceFileName`,
        fileObj.docName,
      );
      formDataToUploadCompliance.append(
        `complianceDocUploadDtos[${index}].complianceFile`,
        fileObj.file,
      ); //this is file obj
    });
    try {
      const response = await fetch(hostName + POST_PROPERTY_COMPLIANCE_DOCS, {
        method: "POST",
        body: formDataToUploadCompliance,
        headers: {
          Authorization: "Bearer " + userObj?.token,
        },
      });
      console.log("response", response, savedFloorImages);
      if (response?.status === 401) {
        window.location.href = generatePath("/client/:clientNameParam/", {
          clientNameParam,
        });
      }
      if (response.status !== 200) {
        throw new Error(`HTTP error! status: ${response?.status}`);
      } else {
        return await response.json();
      }
    } catch (error) {
      return;
    } finally {
      setLoading(false);
    }
  };

  const handelDeleteSavedCompDoc = async (fileObj) => {
    try {
      const deleteResponse = await http.delete(
        DELETE_COMPLIANCE_DOC +
          `?ComplianceDocFileID=${fileObj?.fileId}&PropertyId=${editPropertyDetails?.propertyMasterId}&ClientId=${clientId}`,
      );
      if (deleteResponse.status === 200) {
        setTimeout(() => {
          setToastData({
            toastShow: true,
            toastType: "success",
            toastString: "Document has been successfully deleted.",
          });
        }, 2000);

        editPropertyFloorDetails();
      } else {
        setTimeout(() => {
          setToastData({
            toastShow: true,
            toastType: "failure",
            toastString: "Error in deleting document, please try again.",
          });
        }, 2000);
        editPropertyFloorDetails();
      }
    } catch (error) {
      console.log("error", error);
    }
  };

  //eslint-disable-next-line no-unused-vars
  const handelDeleteSavedCompDocBlock = async (fileObj, block) => {
    // const fileids = fileObj.map(item => item.docId);
    const payload = {
      blockId: block.blockId,
      propertyMasterId: editPropertyDetails.propertyMasterId,
      documentIds: [fileObj.docId],
    };

    try {
      const deleteResponse = await http.delete(DELETE_BLOCK_DOCUMENT, {
        data: payload,
        headers: {
          "Content-Type": "application/json",
        },
      });
      if (deleteResponse.status === 200) {
        setBlockData((prev) =>
          prev.map((b) =>
            b.blockId === block.blockId
              ? {
                  ...b,
                  savedadditionalDocsArr: b.savedadditionalDocsArr.filter(
                    (doc) => doc.docId !== fileObj.docId,
                  ),
                }
              : b,
          ),
        );
        setTimeout(() => {
          setToastData({
            toastShow: true,
            toastType: "success",
            toastString: "Document has been successfully deleted.",
          });
        }, 2000);

        editPropertyFloorDetails();
      } else {
        setTimeout(() => {
          setToastData({
            toastShow: true,
            toastType: "failure",
            toastString: "Error in deleting document, please try again.",
          });
        }, 2000);
        editPropertyFloorDetails();
      }
    } catch (error) {
      console.log("error", error);
    }
  };
  // const handleFloorInputChange = (e) => {
  //   let digits = e.target.value.replace(/\D/g, "");

  //   if (digits.length > 3) {
  //     digits = digits.slice(0, 3);
  //   }

  //   const numericValue = digits === "" ? "" : String(parseInt(digits, 10));

  //   // setShowFloorImages(Number(numericValue) > 0);
  //   setPropertyTotalFloor(numericValue);
  // };

  // const handelDeleteSavedFloorImage = async (fileObj) => {
  //   //const floorArr = [fileObj]
  //   // const formDataToDeleteFloorPlan = new FormData();
  //   // formDataToDeleteFloorPlan.append(
  //   //   "ClientId",
  //   //   clientId
  //   // );
  //   // formDataToDeleteFloorPlan.append("PropertyMasterId", editPropertyDetails?.propertyMasterId);
  //   // floorArr.forEach((floor, index) => {
  //   //   formDataToDeleteFloorPlan.append(`FloorNumber[${index}]`, floor);
  //   // })
  //   try {
  //     const deleteResponse = await http.delete(
  //       DELETE_FLOOR_PLAN_IMAGE +
  //         `?ClientId=${clientId}&PropertyMasterId=${editPropertyDetails?.propertyMasterId}&FloorNumber=${fileObj}`,
  //     );
  //     if (deleteResponse.status === 200) {
  //       setTimeout(() => {
  //         setToastData({
  //           toastShow: true,
  //           toastType: "success",
  //           toastString: "Floor Plan Image has been successfully deleted.",
  //         });
  //       }, 2000);

  //       editPropertyFloorDetails();
  //     } else {
  //       setTimeout(() => {
  //         setToastData({
  //           toastShow: true,
  //           toastType: "failure",
  //           toastString: "Error in deleting Image, please try again.",
  //         });
  //       }, 2000);
  //       editPropertyFloorDetails();
  //     }
  //   } catch (error) {
  //     console.log("error", error);
  //   }
  // };

  const handleDeleteBuildingImage = async (blockId, index) => {
    // const selectedBlock = blockData.filter((x) => x.blockId === blockId)?.[0];
    // if (selectedBlock?.buildingNotSaved) {
    //   removeBuildingImage(blockId, index);
    // } else {
    //   const imageToDelete = selectedBlock?.bluildingBlobUrl;
    //   try {
    //     if (
    //       imageToDelete.trim() !== "" ||
    //       imageToDelete !== null ||
    //       imageToDelete !== undefined
    //     ) {
    //       const response = await http.delete(DELETE_IMAGE_API + imageToDelete);
    //       if (response.status === 200) {
    //         removeBuildingImage(blockId, index);
    //         setToastData({
    //           toastShow: true,
    //           toastType: "success",
    //           toastString: "Image Deleted Successfully",
    //         });
    //       } else {
    //         setToastData({
    //           toastShow: true,
    //           toastType: "Failure",
    //           toastString: "Could not delete, please refresh and try again",
    //         });
    //       }
    //     }
    //   } catch (error) {
    //     setToastData({
    //       toastShow: true,
    //       toastType: "Failure",
    //       toastString: "Could not delete, please refresh and try again",
    //     });
    //   }
    // }
    removeBuildingImage(blockId, index);
  };

  const handleDeleteBlockData = async (block) => {
    const params = new URLSearchParams();
    params.append("blockId", block.blockId);
    params.append("propertyMasterId", editPropertyDetails?.propertyMasterId);
    const queryString = params.toString();

    try {
      const deleteResponse = await http.delete(
        DELETE_BLOCK_DATA + `?${queryString}`,
      );
      if (deleteResponse.status === 200) {
        setToastData({
          toastShow: true,
          toastType: "success",
          toastString: "Building details have been successfully deleted.",
        });

        editPropertyFloorDetails();
        getBlockDetails();
      } else {
        setToastData({
          toastShow: true,
          toastType: "failure",
          toastString: "Error in deleting building, please try again.",
        });
      }
    } catch (error) {
      console.log("error", error);
      setToastData({
        toastShow: true,
        toastType: "failure",
        toastString: "Error in deleting building, please try again.",
      });
    }
  };

  //delete floor
  //eslint-disable-next-line no-unused-vars
  const handelDeleteSavedFloorImage = async (floorNumber, blockId) => {
    const payload = {
      blockId: blockId,
      propertyMasterId: editPropertyDetails?.propertyMasterId,
      floorNumbers: [Number(floorNumber)],
    };

    try {
      const deleteResponse = await http.delete(DELETE_FLOOR_PLAN_IMAGE, {
        data: payload,
        headers: {
          "Content-Type": "application/json",
        },
      });

      if (deleteResponse.status === 200) {
        setToastData({
          toastShow: true,
          toastType: "success",
          toastString: "Floor Plan Image has been successfully deleted.",
        });

        editPropertyFloorDetails();
        getBlockDetails();
      } else {
        setToastData({
          toastShow: true,
          toastType: "failure",
          toastString: "Error in deleting Image, please try again.",
        });
      }
    } catch (error) {
      console.log("error", error);
    }
  };

  //eslint-disable-next-line no-unused-vars
  const uploadPropertyimage = async () => {
    setLoading(true);
    const formDataToUploadPropertyImage = new FormData();
    formDataToUploadPropertyImage.append("ClientId", clientId);
    formDataToUploadPropertyImage.append(
      "PropertyMasterId",
      editPropertyDetails?.propertyMasterId,
    );
    formDataToUploadPropertyImage.append("PropertyImage", propertyImage);
    try {
      const response = await fetch(hostName + UPLOAD_PROPERTY_UPDATE_IMAGE, {
        method: "POST",
        body: formDataToUploadPropertyImage,
        headers: {
          Authorization: "Bearer " + userObj?.token,
        },
      });
      if (response?.status === 401) {
        window.location.href = generatePath("/client/:clientNameParam/", {
          clientNameParam,
        });
      }
      if (response.status !== 200) {
        throw new Error(`HTTP error! status: ${response?.status}`);
      } else {
        return await response.json();
      }
    } catch (error) {
      return {};
    } finally {
      setLoading(false);
    }
  };

  const handleUpdateProperty = async (event) => {
    event.preventDefault();
    setValidationFlag(false);
    // Client validation (only when field is enabled)
    if (
      isClientFieldEnabled &&
      (!selectedClient ||
        selectedClient === "" ||
        selectedClient === "add-new") &&
      newClientName
    ) {
      const isExistClientname = await checkCompanyClient();
      if (isExistClientname) {
        if (clientRef.current) {
          clientRef.current.style.border = "1px solid red";
        }
        setErrorObject({ ...errorObject, client: "clientname already exists" });
        setValidationFlag(true);
        clientRef.current.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
        clientRef.current.focus();
        return;
      }
    }
    const validationErrors = validate();
    if (Object.keys(validationErrors).length > 0) {
      setErrorObject(validationErrors);
      setValidationFlag(true);
      if (validationErrors.blockData || validationErrors.blockFileError) {
        setActiveTab("Block");
        const firstBlockErrorIndex = blockData.filter(
          (block) => block.hasFormErrors,
        )[0]?.id;
        setTimeout(() => {
          if (
            firstBlockErrorIndex &&
            inputRefs.block?.current[firstBlockErrorIndex]
          ) {
            inputRefs.block.current[firstBlockErrorIndex].scrollIntoView({
              behavior: "smooth",
              block: "center",
            });
          }
        }, 500);
      } else {
        const firstErrorKey = Object.keys(validationErrors)[0];
        if (firstErrorKey && inputRefs[firstErrorKey]?.current) {
          inputRefs[firstErrorKey].current.scrollIntoView({
            behavior: "smooth",
            block: "center",
          });
          inputRefs[firstErrorKey].current.focus();
        }
      }
    } else {
      setLoading(true);

      let compResponse = [];
      if (files && files.length > 0) {
        const responseComplianceDocs = await uploadComplianceDocs(files);
        console.log("compl", responseComplianceDocs);
        if (responseComplianceDocs?.result?.isSuccess === true) {
          responseComplianceDocs?.result?.complianceDocFiles?.forEach(
            (file) => {
              const newObj = {
                complianceType: file.complianceType,
                complianceFileName: file.complianceFileName,
                complianceDocFileUrl: file.complianceDocFileUrl,
                fileId: file.fileId,
              };
              compResponse.push(newObj);
            },
          );
        }
      }
      // let newPropertyImage = "";
      // if (propertyImage && loadExistingFile) {
      //   const responsePropertyImage = await uploadPropertyimage();
      //   console.log("prop img", responsePropertyImage);
      //   if (responsePropertyImage?.result?.isSuccess === true) {
      //     newPropertyImage = responsePropertyImage?.result?.bloblUrl[0];
      //   }
      // }
      const formDataToUploadProperty = new FormData();
      // formDataToUploadProperty.append(
      //   "PropertyImageFile",
      //   loadExistingFile ? propertyImage : ""
      // );
      formDataToUploadProperty.append(
        "propertyImage",
        loadExistingFile ? "" : propertyImage,
      );
      formDataToUploadProperty.append("clientId", clientId);
      formDataToUploadProperty.append("propertyName", propertyName);
      formDataToUploadProperty.append("propertyLocation", propertyAddress);
      formDataToUploadProperty.append("postalCode", propertyPostalCode);
      formDataToUploadProperty.append(
        "isActive",
        editPropertyDetails?.isActive,
      );
      // formDataToUploadProperty.append(
      //   "cityId",
      //   propertyCity?.cityId ? propertyCity.cityId : "",
      // );
      if (propertyCity?.cityId === "add-new") {
        formDataToUploadProperty.append("cityId", "0");
        formDataToUploadProperty.append("isNewCity", true);
        formDataToUploadProperty.append(
          "cityName",
          propertyCity.cityName || newCityName,
        );
      } else {
        formDataToUploadProperty.append("cityId", propertyCity?.cityId || "");
        formDataToUploadProperty.append("isNewCity", false);
        formDataToUploadProperty.append("cityName", "");
      }
      formDataToUploadProperty.append(
        "propertyMasterId",
        editPropertyDetails?.propertyMasterId,
      );
      formDataToUploadProperty.append("NumberOfBlocks", numberofBlocks);
      formDataToUploadProperty.append("Latitude", siteLatitude);
      formDataToUploadProperty.append("Longitude", siteLongitude);

      // EXISTING CLIENT SELECTED
      if (selectedClient && selectedClient !== "add-new") {
        formDataToUploadProperty.append(
          "companyClientMappingId",
          selectedClient,
        );
      }

      // NEW CLIENT ENTERED
      if (newClientName && newClientName.trim()) {
        formDataToUploadProperty.append(
          "companyClientName",
          newClientName.trim(),
        );
      }

      const selectedInspector = propertyInspector?.map((u) => u.value);
      selectedInspector.forEach((value) => {
        formDataToUploadProperty.append("inspectors[]", value); // Use '[]' in the key for server-side parsing as an array
      });
      //formDataToUploadProperty.append("InspectorIds", selectedInspector);
      const selectApprover = propertyApprover?.map((u) => u.value);
      selectApprover.forEach((value) => {
        formDataToUploadProperty.append("approvers[]", value); // Use '[]' in the key for server-side parsing as an array
      });
      if (savedCompDocs && savedCompDocs.length > 0) {
        savedCompDocs?.forEach((fileObj, index) => {
          formDataToUploadProperty.append(
            `complianceDocs[${index}].complianceType`,
            fileObj.complianceType || 0,
          );
          formDataToUploadProperty.append(
            `complianceDocs[${index}].complianceFileName`,
            fileObj.complianceFileName,
          );
          formDataToUploadProperty.append(
            `complianceDocs[${index}].complianceDocFileUrl`,
            fileObj.complianceDocFileUrl,
          );
          formDataToUploadProperty.append(
            `complianceDocs[${index}].fileId`,
            fileObj.fileId,
          );
        });
      } else if (compResponse.length > 0) {
        compResponse?.forEach((fileObj, index) => {
          formDataToUploadProperty.append(
            `complianceDocs[${index}].complianceType`,
            fileObj.complianceType || 0,
          );
          formDataToUploadProperty.append(
            `complianceDocs[${index}].complianceFileName`,
            fileObj.complianceFileName,
          );
          formDataToUploadProperty.append(
            `complianceDocs[${index}].complianceDocFileUrl`,
            fileObj.complianceDocFileUrl,
          );
          formDataToUploadProperty.append(
            `complianceDocs[${index}].fileId`,
            fileObj.fileId,
          );
        });
      } else {
        formDataToUploadProperty.append(`complianceDocs`, null);
      }
      // formDataToUploadProperty.append(
      //   "totalNoOfFloors",
      //   propertyTotalFloor ? parseInt(propertyTotalFloor, 10) : null
      // );
      formDataToUploadProperty.append("propertyStatus", propertyStatus);
      console.log(
        "formDataToUploadProperty",
        formDataToUploadProperty,
        selectApprover,
        selectedInspector,
      );
      // console.log("floorEntries", floorEntries);

      let complianceDocsPay = [];
      if (savedCompDocs && savedCompDocs.length > 0) {
        savedCompDocs.forEach((file) => {
          const newObj = {
            fileId: file.fileId,
            complianceType: file.complianceType,
            complianceFileName: file.complianceFileName,
            complianceDocFileUrl: file.complianceDocFileUrl,
          };
          complianceDocsPay.push(newObj);
        });
      }
      if (compResponse.length > 0) {
        compResponse.forEach((file) => {
          const newObj = {
            fileId: file.fileId,
            complianceType: file.complianceType,
            complianceFileName: file.complianceFileName,
            complianceDocFileUrl: file.complianceDocFileUrl,
          };
          complianceDocsPay.push(newObj);
        });
      }

      const newFormPayload = {
        clientId: clientId,
        propertyMasterId: editPropertyDetails?.propertyMasterId,
        isActive: editPropertyDetails?.isActive,
        propertyName: propertyName,
        propertyLocation: propertyAddress,
        postalCode: propertyPostalCode,
        // propertyImage: loadExistingFile ? newPropertyImage : propertyImage,
        // cityId: propertyCity?.cityId ? propertyCity.cityId.toString() : "",
        cityId:
          propertyCity?.cityId && propertyCity.cityId !== "add-new"
            ? propertyCity.cityId.toString()
            : "0",

        isNewCity: propertyCity?.cityId === "add-new",

        cityName:
          propertyCity?.cityId === "add-new"
            ? propertyCity.cityName || newCityName
            : "",

        inspectors: selectedInspector,
        approvers: selectApprover,
        complianceDocs: [...complianceDocsPay],
        propertyStatus: propertyStatus,
        numberOfBlocks: numberofBlocks,
        latitude: siteLatitude,
        longitude: siteLongitude,
        companyClientMappingId:
          selectedClient && selectedClient !== "add-new"
            ? selectedClient
            : null,

        companyClientName:
          newClientName && newClientName.trim() ? newClientName.trim() : null,
      };

      console.log("newFormPayload", newFormPayload);

      try {
        const response = await http.put(
          UPDATE_PROPERTY_BY_CLIENT_ID,
          JSON.stringify(newFormPayload),
        );
        console.log("update response", response);
        if (response?.status === 401) {
          window.location.href = generatePath("/client/:clientNameParam/", {
            clientNameParam,
          });
        }
        // if (response?.status === 200 && isEmptyFloorEntries) {
        //   setTimeout(() => {
        //     setToastData({
        //       toastShow: true,
        //       toastType: "success",
        //       toastString: "Property has been successfully updated.",
        //     });
        //   }, 2000);
        //   setRenderUpdateProperty(false);
        //   handleGetAllPropertyByClinetID(clientId);
        // }

        if (response.status === 200 && propertyStatus === "Active") {
          const formDataToUploadBlocks = new FormData();
          formDataToUploadBlocks.append(
            "PropertyMasterId",
            editPropertyDetails.propertyMasterId,
          );
          blockData.forEach((block, index) => {
            console.log("block", block.blockName);
            const blockid =
              block.blockId === undefined || block.blockId === null
                ? crypto.randomUUID()
                : block.blockId;
            formDataToUploadBlocks.append(`Blocks[${index}].BlockId`, blockid);
            formDataToUploadBlocks.append(
              `Blocks[${index}].BlockName`,
              block.blockName,
            );
            formDataToUploadBlocks.append(
              `Blocks[${index}].TotalFloors`,
              block.totalFloors,
            );
            // if(block.buildingImage && block.buildingImage instanceof File){
              formDataToUploadBlocks.append(
                `Blocks[${index}].BuildingImage[0]`,
                block.buildingImage || "",
              );
            // }
            // if(block.bluildingBlobUrl){
              formDataToUploadBlocks.append(
                `Blocks[${index}].BuildingImageUrl[0]`,
                block.bluildingBlobUrl || "",
              );  
            // }
            // block.floorArray?.forEach((floor, ind) => {
            //   const baseKey = `Blocks[${index}]`;

            //   // Floor number
            //   formDataToUploadBlocks.append(
            //     `${baseKey}.FloorNumbers[${ind}]`,
            //     floor.floor ?? "",
            //   );

            //   // New image upload
            //   if (floor.floorNotSaved && floor.image instanceof File) {
            //     formDataToUploadBlocks.append(
            //       `${baseKey}.FloorImages[${ind}]`,
            //       floor.image,
            //     );
            //   }

            //   // Existing image URL
            //   if (!floor.floorNotSaved && floor.floorBlobUrl) {
            //     formDataToUploadBlocks.append(
            //       `${baseKey}.FloorImagesUrl[${ind}]`,
            //       floor.floorBlobUrl,
            //     );
            //   }
            // });
            block.floorArray?.forEach((floor, ind) => {
              console.log("block", block.blockName, floor.floor, floor.image, floor.floorNotSaved);
              formDataToUploadBlocks.append(
                `Blocks[${index}].FloorNumbers[${ind}]`,
                floor.floor || "",
              );
              formDataToUploadBlocks.append(
                `Blocks[${index}].FloorImages[${ind}]`,
                floor.floorNotSaved ? floor.image : "",
              );
              formDataToUploadBlocks.append(
              `Blocks[${index}].FloorImagesUrl[${ind}]`,
              floor.floorNotSaved ? "" : floor.floorBlobUrl || "",
            );
            });
            block.additionalDocsArr.length > 0 &&
              block.additionalDocsArr.forEach((doc, ind) => {
                console.log("block", block.blockName, doc.docName);

                formDataToUploadBlocks.append(
                  `Blocks[${index}].DocumentTypes[${ind}]`,
                  doc.type,
                );
                formDataToUploadBlocks.append(
                  `Blocks[${index}].DocumentFileNames[${ind}]`,
                  doc.docName,
                );
                formDataToUploadBlocks.append(
                  `Blocks[${index}].DocumentFiles[${ind}]`,
                  doc.file,
                );
              });
          });

          const responseFloorPlans = await fetch(
            hostName + UPDATE_BLOCKS_DATA,
            {
              method: "PUT",
              body: formDataToUploadBlocks,
              headers: {
                Authorization: "Bearer " + userObj?.token,
              },
            },
          );
          if (responseFloorPlans?.status === 401) {
            window.location.href = generatePath("/client/:clientNameParam/", {
              clientNameParam,
            });
          }
          // const responseFloorPlansData = await responseFloorPlans.json();
          if (responseFloorPlans.status === !200) {
            setToastData({
              toastShow: true,
              toastType: "failure",
              toastString: "Site has not been updated, please try again.",
            });
            setTimeout(() => {
              setRenderUpdateProperty(false);
              handleGetAllPropertyByClinetID(clientId);
            }, 2000);
            // window.location.reload();
          }
          if (responseFloorPlans.status === 200) {
            setToastData({
              toastShow: true,
              toastType: "success",
              toastString: "Site has been successfully updated.",
            });
            setTimeout(() => {
              setRenderUpdateProperty(false);
              handleGetAllPropertyByClinetID(clientId);
              // window.location.reload();
            }, 2000);
          }
        } else if (response.status === 200 && propertyStatus === "Archive") {
          setToastData({
            toastShow: true,
            toastType: "success",
            // toastString: response?.message,
            toastString: "Site has been  updated successfully ",
          });
          setTimeout(() => {
            setRenderUpdateProperty(false);
            handleGetAllPropertyByClinetID(clientId);
            // window.location.reload();
          }, 2000);
        } else if (response.status === 400) {
          setToastData({
            toastShow: true,
            toastType: "failure",
            toastString: response?.message,
          });
        } else {
          throw new Error(`HTTP error! status: ${response?.status}`);
        }
      } catch (error) {
        return {};
      } finally {
        setLoading(false);
      }
    }
  };

  // const checkFloorEntries = (entries) => {
  //   const isObjectValuesEmpty = (obj) => {
  //     return Object.values(obj).every(
  //       (value) =>
  //         value === null ||
  //         value === undefined ||
  //         value === "" ||
  //         value === "Select" ||
  //         value === "Please select floor" ||
  //         value === "Please upload floor plan image"
  //     );
  //   };

  //   return entries.every(isObjectValuesEmpty);
  // };
  const handleSelect = (val) => {
    const foundObject = cityList.find(
      (option) => String(option.cityId) === String(val),
    );
    setPropertyCity(foundObject);
    setIsCityTyping(false);

    // } else if (e.target.name === "block") {
    //   const foundObject = blocksList.find(
    //     (option) => option.blockName === e.target.value
    //   );
    //   // setPropertyBlockName(foundObject);
    // }
    setErrorObject((prevErrors) => ({
      ...prevErrors,
      city: val ? "" : prevErrors.city,
    }));
  };

  const getCityOptionLabel = useCallback((cityOption) => {
    return cityOption?.cityName || "";
  }, []);

  const getCityOptionValue = useCallback((cityOption) => {
    return cityOption?.cityId || "";
  }, []);

  useEffect(() => {
    const cityInput = inputRefs?.city?.current;
    if (!cityInput || showNewCityInput) return;

    const handleCityKeyDown = (event) => {
      const isEditingKey =
        event.key === "Backspace" ||
        event.key === "Delete" ||
        event.key.length === 1;

      if (isEditingKey && propertyCity?.cityId) {
        setIsCityTyping(true);
        setPropertyCity(null);

        // Start fresh search when user edits a selected city.
        cityInput.value = "";
      }
    };

    cityInput.addEventListener("keydown", handleCityKeyDown);
    return () => {
      cityInput.removeEventListener("keydown", handleCityKeyDown);
    };
  }, [propertyCity?.cityId, showNewCityInput]);

  const makeDefaultBlock = (id) => ({
    id,
    blockId: id,
    blockName: "",
    totalFloors: 0,
    showFloorImages: false,
    floorArray: [],
    additionalDocsArr: [],
    fileError: "",
    fileShowValidation: false,
    formErrors: {},
    hasFormErrors: false,
    buildingImage: null,
    previewBuildingImage: "",
    buildingFileName: "",
    buildingImageType: "",
  });

  // useEffect(() => {
  //   const nextLen = Math.max(0, Number(numberofBlocks) || 0);
  //   const newBlocks = Array.from({ length: nextLen }, (_, i) => {
  //     const blockId = blockOrder[i] ?? crypto.randomUUID();
  //     return blockDataArchive.find((block) => block.blockId === blockId) ?? makeDefaultBlock(blockId);
  //   });
  //       console.log("useeffect", blockOrder, blockDataArchive, newBlocks);
  //   setBlockData(newBlocks);
  // }, [numberofBlocks]);

  useEffect(() => {
    const nextLen = Math.max(0, Number(numberofBlocks) || 0);

    let nextBlockOrder = [...blockOrder];
    let nextBlockArchive = [...blockDataArchive];

    // ✅ 1. If numberOfBlocks increased, add missing blocks
    if (nextLen > nextBlockOrder.length) {
      const blocksToAdd = nextLen - nextBlockOrder.length;

      for (let i = 0; i < blocksToAdd; i++) {
        const newBlockId = crypto.randomUUID();

        nextBlockOrder.push(newBlockId);
        nextBlockArchive.push(makeDefaultBlock(newBlockId));
      }

      // ✅ sync state only once
      setBlockOrder(nextBlockOrder);
      setBlockDataArchive(nextBlockArchive);
    }

    // ✅ 2. Build blockData from the synced sources
    const newBlocks = Array.from({ length: nextLen }, (_, i) => {
      const blockId = nextBlockOrder[i];
      return (
        nextBlockArchive.find((block) => block.blockId === blockId) ??
        makeDefaultBlock(blockId)
      );
    });

    console.log("useeffect", nextBlockOrder, nextBlockArchive, newBlocks);
    setBlockData(newBlocks);
  }, [numberofBlocks]);

  const removeBlock = (blockId) => {
    // Remove from order
    setBlockOrder((prev) => prev.filter((id) => id !== blockId));

    setBlockDataArchive((prev) => {
      return prev.filter((b) => b.blockId !== blockId);
    });

    // 2️⃣ Decrease count (this triggers useEffect rebuild)
    setNumberofBlocks((prev) => Math.max(0, prev - 1));
  };

  const AddBlock = () => {
    // const newBlockId = crypto.randomUUID();
    // setBlockOrder((prev) => [...prev, newBlockId]);
    // setBlockDataArchive((prev) => [...prev, makeDefaultBlock(newBlockId)]);
    setNumberofBlocks((prev) => parseInt(prev) + 1);
  };

  const buildMergedFloorArray = (prevFloors, normalized) => {
    // Ensure we always work with an array
    const prevByFloor = new Map((prevFloors ?? []).map((f) => [f.floor, f]));

    // Build the target range 1..normalized and merge existing data
    return Array.from({ length: normalized }, (_, i) => {
      const floorNo = i + 1;
      const prev = prevByFloor.get(floorNo);
      return {
        blockId: prev?.blockId ?? null,
        blockFloorId: prev?.blockFloorId ?? null,
        floor: floorNo,
        loadedImage: prev?.loadedImage ?? false,
        image: prev?.image ?? null, //  keep existing image if present
        floorError: prev?.floorError ?? "", //  keep existing error if present
        floorNotSaved: prev?.floorNotSaved ?? true, //  keep existing notSaved flag if present
        floorPdfUrl: prev?.floorPdfUrl ?? null, //  keep existing PDF URL if present
        floorPdfName: prev?.floorPdfName ?? null, //  keep existing PDF name if present
        floorBlobUrl: prev?.floorBlobUrl ?? null, //  keep existing Blob URL if present
      };
    });
  };

  const handleTotalFloorsBlur = (index) => {
  const totalFloors = Number(blockDataArchive[index]?.totalFloors || 0);
  // if (totalFloors <= 0) return;

  // ✅ Always merge from ARCHIVE (source of truth)
  const sourceFloors =
    blockDataArchive[index]?.floorArray ?? [];

  const nextFloors = buildMergedFloorArray(
    sourceFloors,
    totalFloors
  );

  setBlockData((prev) =>
    prev.map((item, i) =>
      i === index
        ? {
            ...item,
            showFloorImages: true,
            floorArray: nextFloors,
          }
        : item
    )
  );

  setBlockDataArchive((prev) =>
    prev.map((item, i) =>
      i === index
        ? {
            ...item,
            showFloorImages: true,
            floorArray: nextFloors,
          }
        : item
    )
  );
};

  const handleBlockDataChange = (index, field, val) => {
    if (field === "totalFloors") {
      let digits = val.replace(/\D/g, ""); // keep only 0–9
      if (digits.length > 3) {
        digits = digits.slice(0, 3);
      }
      const normalized = digits === "" ? "" : String(parseInt(digits, 10));
      const numericValue = normalized === "" ? 0 : Number(normalized);
      // const floorarr = Array.from({ length: normalized }, (_, i) => ({
      //   floor: i + 1,
      //   image: null,
      //   floorError: "",
      // }));
      // const nextFloors = normalized === "" 
      //   ? blockData[index].floorArray // ✅ preserve previous data 
      //   : buildMergedFloorArray(
      //     blockData[index].floorArray,
      //     normalized,
      //   );
      // console.log("next", nextFloors);
      setBlockData((prev) =>
        prev.map((item, i) =>
          i === index
            ? {
                ...item,
                totalFloors: normalized,
                showFloorImages: normalized !== "" && numericValue > 0,
                // floorArray: nextFloors,
                formErrors: {
                  ...item.formErrors,
                  [field]: "", //  clear error for this field only
                },
              }
            : item,
        ),
      );
      setBlockDataArchive((prev) =>
        prev.map((item, i) =>
          i === index
            ? {
                ...item,
                totalFloors: normalized,
                showFloorImages: normalized !== "" && numericValue > 0,
                // floorArray: nextFloors,
                formErrors: {
                  ...item.formErrors,
                  [field]: "", //  clear error for this field only
                },
              }
            : item,
        ),
      );
    } else if (field === "additionalDocsArr") {
      setBlockData((prev) =>
        prev.map((item, i) => {
          if (i !== index) return item;

          const prevFieldValue = item[field]; // e.g., previous additionalDocsArr

          const nextFieldValue =
            typeof val === "function" ? val(prevFieldValue) : val;

          return { ...item, [field]: nextFieldValue };
        }),
      );
      setBlockDataArchive((prev) =>
        prev.map((item, i) => {
          if (i !== index) return item;

          const prevFieldValue = item[field]; // e.g., previous additionalDocsArr

          const nextFieldValue =
            typeof val === "function" ? val(prevFieldValue) : val;

          return { ...item, [field]: nextFieldValue };
        }),
      );
    } else if (field === "buildingImage") {
      const file = val.target.files?.[0] ?? null;
      if (file && file.size > 10 * 1024 * 1024) {
        setToastData({
          toastShow: true,
          toastType: "failure",
          toastString: "File size should not exceed 10 MB"
        });
        const el = fileInputRefsBuilding.current[index];
         if (el) el.value = "";
        return;
      }
      if (file) {
        const previewUrl = URL.createObjectURL(file);

        setBlockData((prev) =>
          prev.map((item, i) =>
            i === index
              ? {
                  ...item,
                  buildingImage: file,
                  previewBuildingImage: previewUrl,
                  buildingFileName: file.name,
                  buildingImageType: file.type,
                  buildingNotSaved: true,
                }
              : item,
          ),
        );
        setBlockDataArchive((prev) =>
          prev.map((item, i) =>
            i === index
              ? {
                  ...item,
                  buildingImage: file,
                  previewBuildingImage: previewUrl,
                  buildingFileName: file.name,
                  buildingImageType: file.type,
                  buildingNotSaved: true,
                }
              : item,
          ),
        );
      }
    } else {
      setBlockData((prev) =>
        prev.map((item, i) =>
          i === index
            ? {
                ...item,
                [field]: val,
                formErrors: {
                  ...item.formErrors,
                  [field]: "", // clear error for this field only
                },
              }
            : item,
        ),
      );
      setBlockDataArchive((prev) =>
        prev.map((item, i) =>
          i === index
            ? {
                ...item,
                [field]: val,
                formErrors: {
                  ...item.formErrors,
                  [field]: "", // clear error for this field only
                },
              }
            : item,
        ),
      );
    }
  };

  const removeBuildingImage = (blockId, blockIndex) => {
    setBlockData((prev) =>
      prev.map((block) => {
        if (block.blockId !== blockId) return block;

        return {
          ...block,
          buildingImage: null,
          previewBuildingImage: "",
          buildingFileName: "",
          buildingImageType: "",
          bluildingBlobUrl: "",
        };
      }),
    );
    setBlockDataArchive((prev) =>
      prev.map((block) => {
        if (block.blockId !== blockId) return block;

        return {
          ...block,
          buildingImage: null,
          previewBuildingImage: "",
          buildingFileName: "",
          buildingImageType: "",
          bluildingBlobUrl: "",
        };
      }),
    );
    const el = fileInputRefsBuilding.current[blockIndex];
    if (el) el.value = "";
  };

  const handleBlockFloorImageChange = (blockIndex, floorNumber, e) => {
    const file = e.target.files?.[0] ?? null;

    setBlockData((prev) =>
      prev.map((block, i) => {
        if (i !== blockIndex) return block;

        const nextFloorArray = block.floorArray.map((f) =>
          f.floor === floorNumber
            ? { ...f, image: file, floorError: "", floorNotSaved: true }
            : f,
        );

        return {
          ...block,
          floorArray: nextFloorArray,
          fileError: "",
          fileShowValidation: false,
        };
      }),
    );
    setBlockDataArchive((prev) =>
      prev.map((block, i) => {
        if (i !== blockIndex) return block;

        const nextFloorArray = block.floorArray.map((f) =>
          f.floor === floorNumber
            ? { ...f, image: file, floorError: "", floorNotSaved: true }
            : f,
        );

        return {
          ...block,
          floorArray: nextFloorArray,
          fileError: "",
          fileShowValidation: false,
        };
      }),
    );
  };

  const removeFloorImage = (blockIndex, floorNumber) => {
    setBlockData((prev) =>
      prev.map((block, i) => {
        if (i !== blockIndex) return block;

        const nextFloorArray = block.floorArray.map((f) =>
          // f.floor === floorNumber ? { ...f, image: null } : f,
          f.floor === floorNumber
            ? { ...f, image: null, loadedImage: false, floorBlobUrl: "" }
            : f,
        );

        return { ...block, floorArray: nextFloorArray };
      }),
    );
    setBlockDataArchive((prev) =>
      prev.map((block, i) => {
        if (i !== blockIndex) return block;

        const nextFloorArray = block.floorArray.map((f) =>
          // f.floor === floorNumber ? { ...f, image: null } : f,
          f.floor === floorNumber
            ? { ...f, image: null, loadedImage: false, floorBlobUrl: "" }
            : f,
        );

        return { ...block, floorArray: nextFloorArray };
      }),
    );

    const el = fileInputRefs.current[blockIndex]?.[floorNumber];
    if (el) el.value = "";
  };

  const handleKeyDown = (e) => {
    if (e.key === "." || e.key === "e" || e.key === "-") {
      e.preventDefault();
    }
  };

  const fileInputRefs = useRef({}); // nested map: { [blockIndex]: { [floorNumber]: HTMLInputElement } }
  const fileInputRefsBuilding = useRef({}); // map: { [blockIndex]: HTMLInputElement }

  const setFileInputRef = (blockIndex, floorNumber) => (el) => {
    if (!el) return;
    if (!fileInputRefs.current[blockIndex])
      fileInputRefs.current[blockIndex] = {};
    fileInputRefs.current[blockIndex][floorNumber] = el;
  };

  // for building image code
  const setFileInputRefBuilding = (blockIndex) => (el) => {
    if (!el) return;
    if (!fileInputRefsBuilding.current[blockIndex])
      fileInputRefsBuilding.current[blockIndex] = {};
    fileInputRefsBuilding.current[blockIndex] = el;
  };

  return (
    <>
      <div className="d-flex dashboard_body flex-column py-1 w-100 mt-2">
        <div className="dashboard_header">
          <h2 className="mb-0">Update Site Details</h2>
          <div className="d-flex flex-row justify-content-between">
            <p className="header-description">
              Update site/building details below.
            </p>
          </div>
        </div>
        <div className="mb-3 mt-2 tab-container">
          <button
            className={
              activeTab === "Site" ? "btn btn-tab-active" : "btn btn-tab"
            }
            onClick={() => handleTabChange("Site")}
          >
            Site Information
          </button>
          <button
            className={
              activeTab === "Block" ? "btn btn-tab-active" : "btn btn-tab"
            }
            onClick={() => handleTabChange("Block")}
          >
            Building Information
          </button>
        </div>
        {activeTab === "Site" && (
          <>
            <div className="resident-card d-flex flex-column gap-2 mt-3 text-start">
              <h3 className="resident-card-header">Site Information</h3>
              <div className="card-body-uneven-section">
                <div className="form-group">
                  <label htmlFor="name">
                    Name <span style={{ color: "red" }}>*</span>
                  </label>
                  <input
                    type="text"
                    placeholder="Enter site name"
                    id={`name1`}
                    className={errorObject.propertyName ? "input-error" : ""}
                    value={propertyName}
                    onChange={(e) => {
                      setPropertyName(e.target.value);
                      setErrorObject((prevErrors) => ({
                        ...prevErrors,
                        propertyName: e.target.value
                          ? ""
                          : prevErrors.propertyName,
                      }));
                    }}
                    ref={inputRefs.propertyName}
                  />
                  {errorObject.propertyName && (
                    <span className="formError">
                      {errorObject.propertyName}
                    </span>
                  )}
                </div>
                <div className="form-group">
                  <label htmlFor="address1">
                    Address <span style={{ color: "red" }}>*</span>
                  </label>
                  <input
                    type="text"
                    placeholder="Enter site address"
                    id="address"
                    className={errorObject.propertyAddress ? "input-error" : ""}
                    value={propertyAddress}
                    onChange={(e) => {
                      setPropertyAddress(e.target.value);
                      setErrorObject((prevErrors) => ({
                        ...prevErrors,
                        propertyAddress: e.target.value
                          ? ""
                          : prevErrors.propertyAddress,
                      }));
                    }}
                    ref={inputRefs.propertyAddress}
                  />
                  {errorObject.propertyAddress && (
                    <span className="formError">
                      {errorObject.propertyAddress}
                    </span>
                  )}
                </div>
              </div>
              <div className="card-body-three-section">
                <div className="form-group">
                  <label htmlFor="contact1">
                    Post code <span style={{ color: "red" }}>*</span>
                  </label>
                  <input
                    type="text"
                    placeholder="Enter post code"
                    className={errorObject.postalCode ? "input-error" : ""}
                    id={`contact1`}
                    value={propertyPostalCode}
                    onChange={(e) => {
                      let formattedValue = e.target.value
                        .toUpperCase()
                        .replace(/\s+/g, "");
                      if (formattedValue.length > 5) {
                        formattedValue =
                          formattedValue.slice(0, -3) +
                          " " +
                          formattedValue.slice(-3);
                      }
                      setPropertyPostalCode(formattedValue);
                      setErrorObject((prevErrors) => ({
                        ...prevErrors,
                        postalCode: e.target.value ? "" : prevErrors.postalCode,
                      }));
                    }}
                    ref={inputRefs.postalCode}
                  />

                  {errorObject.postalCode && (
                    <span className="formError">{errorObject.postalCode}</span>
                  )}
                </div>
                <div className="form-group">
                  <label htmlFor="contact1">
                    City <span style={{ color: "red" }}>*</span>
                  </label>
                  {/* <AutocompleteInput
                    // masterList={cityList || []}
                    masterList={[...(cityList || [])].sort((a, b) =>
                      (a.cityName || "").localeCompare(
                        b.cityName || "",
                        undefined,
                        {
                          sensitivity: "base",
                        },
                      ),
                    )}
                    getOptionLabel={(c) => c?.cityName || ""}
                    getOptionValue={(c) => c?.cityId || ""}
                    placeholder="Select City"
                    wrapperClassName=""
                    notFoundText="City not found"
                    id={`floor-select`}
                    name="city"
                    inputClassName={
                      errorObject.city
                        ? "input-error form-select"
                        : "form-select"
                    }
                    value={propertyCity?.cityId}
                    onValueChange={(val) => {
                      handleSelect(val);
                      setErrorObject((prevErrors) => ({
                        ...prevErrors,
                        city: val ? "" : prevErrors.city,
                      }));
                    }}
                    aria-label="Floating label select example"
                    inputRef={inputRefs.city}
                  /> */}
                  {!showNewCityInput ? (
                    <AutocompleteInput
                      masterList={cityOptions}
                      getOptionLabel={getCityOptionLabel}
                      getOptionValue={getCityOptionValue}
                      placeholder="Select City"
                      notFoundText="City not found"
                      inputClassName={
                        errorObject.city
                          ? "input-error form-select"
                          : "form-select"
                      }
                      value={
                        isCityTyping ? "__CITY_TYPING__" : propertyCity?.cityId
                      }
                      onValueChange={(val) => {
                        if (val === "add-new") {
                          setIsCityTyping(false);
                          setShowNewCityInput(true);
                          setPropertyCity({ cityId: "add-new", cityName: "" });
                          return;
                        }

                        if (!val) {
                          setIsCityTyping(true);
                          setPropertyCity(null);
                          setErrorObject((prev) => ({
                            ...prev,
                            city: prev.city,
                          }));
                          return;
                        }

                        handleSelect(val);
                        setErrorObject((prev) => ({
                          ...prev,
                          city: val ? "" : prev.city,
                        }));
                      }}
                      inputRef={inputRefs.city}
                    />
                  ) : (
                    <input
                      type="text"
                      placeholder="City Name"
                      className={
                        cityError || errorObject.city ? "input-error" : ""
                      }
                      value={newCityName}
                      onChange={(e) => {
                        const value = e.target.value;
                        setNewCityName(value);
                        setCityError("");

                        if (!value.trim()) {
                          setShowNewCityInput(false);
                          setPropertyCity(null);
                        }
                      }}
                      onKeyDown={(e) => {
                        if (e.key === "Enter") {
                          e.preventDefault();

                          if (!newCityName.trim()) {
                            setCityError("City name cannot be empty");
                            return;
                          }

                          setPropertyCity({
                            cityId: "add-new",
                            cityName: newCityName.trim(),
                          });

                          setShowNewCityInput(false);
                        }

                        if (e.key === "Escape") {
                          setShowNewCityInput(false);
                          setNewCityName("");
                          setPropertyCity(null);
                        }
                      }}
                      ref={inputRefs.city}
                    />
                  )}
                  {errorObject.city && (
                    <span className="formError">{errorObject.city}</span>
                  )}
                </div>
                <div className="form-group">
                  <label htmlFor="contact1">Select Site Status</label>
                  <select
                    id={`floor-select-`}
                    className="form-select"
                    value={propertyStatus}
                    onChange={(e) => setPropertyStatus(e.target.value)}
                    aria-label="Floating label select example"
                  >
                    <option selected value="Active">
                      Active
                    </option>
                    <option value="Archive">Archive</option>
                  </select>
                </div>
                <div className="form-group">
                  <label htmlFor="name">
                    Number of Buildings <span style={{ color: "red" }}>*</span>
                  </label>
                  <input
                    type="number"
                    placeholder="Enter number of buildings"
                    id={`name1`}
                    className={errorObject.numberofBlocks ? "input-error" : ""}
                    min={0}
                    value={numberofBlocks}
                    onChange={(e) => {
                      setNumberofBlocks(e.target.value);
                      //   createObjects(e.target.value);
                      setErrorObject((prevErrors) => ({
                        ...prevErrors,
                        numberofBlocks: e.target.value
                          ? ""
                          : prevErrors.numberofBlocks,
                      }));
                    }}
                    ref={inputRefs.numberofBlocks}
                  />
                  {errorObject.numberofBlocks && (
                    <span className="formError">
                      {errorObject.numberofBlocks}
                    </span>
                  )}
                </div>
                <div className="form-group">
                  <label htmlFor="name">Latitude</label>
                  <input
                    type="text"
                    placeholder="e.g., 53.483959"
                    id={`name1`}
                    value={siteLatitude}
                    className={errorObject.siteLatitude ? "input-error" : ""}
                    onChange={(e) => {
                      setSiteLatitude(e.target.value);
                      setErrorObject((prevErrors) => ({
                        ...prevErrors,
                        siteLatitude: e.target.value
                          ? ""
                          : prevErrors.siteLatitude,
                      }));
                    }}
                    ref={inputRefs.latitude}
                  />
                  {errorObject.siteLatitude && (
                    <span className="formError">
                      {errorObject.siteLatitude}
                    </span>
                  )}
                </div>
                <div className="form-group">
                  <label htmlFor="name">Longitude</label>
                  <input
                    type="text"
                    placeholder="e.g., -2.244644"
                    className={errorObject.siteLongitude ? "input-error" : ""}
                    id={`name1`}
                    value={siteLongitude}
                    onChange={(e) => {
                      setSiteLongitude(e.target.value);
                      setErrorObject((prevErrors) => ({
                        ...prevErrors,
                        siteLongitude: e.target.value
                          ? ""
                          : prevErrors.siteLongitude,
                      }));
                    }}
                    ref={inputRefs.longitude}
                  />
                  {errorObject.siteLongitude && (
                    <span className="formError">
                      {errorObject.siteLongitude}
                    </span>
                  )}
                </div>
                <div className="form-group">
                  <label htmlFor="contact1">
                    Select Inspector(s)
                    <span style={{ color: "red" }}>*</span>
                  </label>
                  <Select
                    isMulti
                    options={inspectorList}
                    value={propertyInspector}
                    required
                    ref={inputRefs.inspectors}
                    className={errorObject.inspectors ? "input-error" : ""}
                    onChange={(e) => {
                      setPropertyInspector(e);

                      setErrorObject((prevErrors) => ({
                        ...prevErrors,
                        inspector: "",
                      }));
                    }}
                    placeholder="Select Inspector"
                    isClearable
                    menuPortalTarget={document.body}
                    styles={{
                      container: (base) => ({
                        ...base,
                        width: "100%",
                        height: "2.81rem",
                      }),
                      control: (base) => ({
                        ...base,
                        minHeight: "2.81rem",
                      }),
                      placeholder: (base) => ({
                        ...base,
                        textAlign: "left",
                        marginLeft: "1rem",
                        color: "#a3a3a3",
                        opacity: 0.8,
                      }),
                      menuPortal: (base) => ({
                        ...base,
                        zIndex: 9999,
                      }),
                    }}
                  />
                  {errorObject.inspectors && (
                    <span className="formError">{errorObject.inspectors}</span>
                  )}
                </div>
                <div className="form-group">
                  <label htmlFor="contact1">
                    Select Approver(s)
                    <span style={{ color: "red" }}>*</span>
                  </label>
                  <Select
                    isMulti
                    className={errorObject.approvers ? "input-error" : ""}
                    options={approverList}
                    value={propertyApprover}
                    required
                    onChange={(e) => {
                      setErrorObject((prevErrors) => ({
                        ...prevErrors,
                        approvers: "",
                      }));
                      setPropertyApprover(e);
                    }}
                    placeholder="Select Approvers"
                    isClearable
                    ref={inputRefs.approvers}
                    menuPortalTarget={document.body}
                    styles={{
                      container: (base) => ({
                        ...base,
                        width: "100%",
                        height: "2.81rem",
                      }),
                      control: (base) => ({
                        ...base,
                        minHeight: "2.81rem",
                      }),
                      placeholder: (base) => ({
                        ...base,
                        textAlign: "left",
                        marginLeft: "1rem",
                        color: "#a3a3a3",
                        opacity: 0.8,
                      }),
                      menuPortal: (base) => ({
                        ...base,
                        zIndex: 9999,
                      }),
                    }}
                  />
                  {errorObject.approvers && (
                    <span className="formError">{errorObject.approvers}</span>
                  )}
                </div>
                {/* <div className="form-group">
                  <label htmlFor="contact1">Main door Image</label>
                  {loadExistingFile && (
                    <div
                      className={`d-flex justify-content-between customerFileBtn align-items-center gap-2 m-0 flex-row`}
                    >
                      <label
                        className="input-group-text mb-0"
                        htmlFor="inputGroupFile"
                        style={{
                          fontSize: "15px",
                          lineHeight: 2,
                          color: " #081634",
                          backgroundColor: "white",
                          border: "1px solid #081634",
                          borderRadius: "5px",
                        }}
                      >
                        Choose File
                      </label>
                      <input
                        type="file"
                        id="inputGroupFile"
                        accept=".jpg, .jpeg, .png, .gif"
                        onChange={handleFileChange}
                      />
                    </div>
                  )}
                  {!loadExistingFile && (
                    <div className="updateMainDoorDiv gap-2 d-flex align-items-justify">
                      <img
                        height="150px"
                        width="180px"
                        alt="Main Door Photo"
                        className="img-fluid w-48 h-48 object-cover rounded-lg border"
                        style={{ marginTop: "5px" }}
                        src={
                          ImageProxyBaseUrl + encodeURIComponent(propertyImage)
                        }
                      />
                      <button
                        onClick={() => {
                          setLoadExistingFile(true);
                        }}
                        className="  btn-primary "
                      >
                        <i className="fa fa-solid fa-pen"></i> Update Image
                      </button>
                    </div>
                  )}
                </div> */}

                <div className="form-group">
                  <label htmlFor="selectClient">
                    Select Client
                    {/* <span style={{ color: "red" }}>*</span> */}
                  </label>
                  {!showNewClientInput ? (
                    <>
                      {!isClientFieldEnabled && selectedClientName ? (
                        <input
                          type="text"
                          className="form-control"
                          value={selectedClientName}
                          disabled
                          readOnly
                        />
                      ) : (
                        <select
                          id="selectClient"
                          className={
                            clientError || errorObject.client
                              ? "form-select input-error"
                              : "form-select"
                          }
                          value={selectedClient}
                          onChange={(e) => {
                            const value = e.target.value;
                            if (value === "add-new") {
                              setShowNewClientInput(true);
                              setSelectedClient(value);
                              setClientError("");
                              setIsClientFieldEnabled(true);
                              setErrorObject((prevErrors) => ({
                                ...prevErrors,
                                client: "",
                              }));
                            } else if (value === "") {
                              // User cleared the selection
                              setSelectedClient(value);
                              setShowNewClientInput(false);
                              setNewClientName("");
                              setClientError("");
                              setErrorObject((prevErrors) => ({
                                ...prevErrors,
                                client: "",
                              }));
                              if (clientRef.current) {
                                clientRef.current.style.border = "";
                              }
                            } else {
                              setSelectedClient(value);
                              setShowNewClientInput(false);
                              setNewClientName("");
                              setClientError("");
                              setErrorObject((prevErrors) => ({
                                ...prevErrors,
                                client: "",
                              }));
                              if (clientRef.current) {
                                clientRef.current.style.border = "";
                              }
                            }
                          }}
                          disabled={!isClientFieldEnabled}
                          ref={clientRef}
                          aria-label="Select Client"
                        >
                          <option value="">Select Client</option>
                          <option value="add-new" className="fw-bold">
                            ➕ Add New Client
                          </option>
                          {clientsList.map((client) => (
                            <option
                              key={client.companyClientMappingId}
                              value={client.companyClientMappingId}
                            >
                              {client.companyClientName}
                            </option>
                          ))}
                        </select>
                      )}
                    </>
                  ) : (
                    <input
                      type="text"
                      placeholder="Enter new client name"
                      className={
                        clientError || errorObject.client ? "input-error" : ""
                      }
                      value={newClientName}
                      disabled={!isClientFieldEnabled}
                      onChange={(e) => {
                        const value = e.target.value;
                        setNewClientName(value);
                        setClientError("");
                        setErrorObject((prevErrors) => ({
                          ...prevErrors,
                          client: "",
                        }));

                        // If text is cleared, show dropdown again
                        if (!value || value.trim() === "") {
                          setShowNewClientInput(false);
                          setSelectedClient("");
                        }
                      }}
                      onKeyDown={(e) => {
                        if (e.key === "Enter") {
                          e.preventDefault();

                          const trimmedName = newClientName.trim();
                          if (!trimmedName) {
                            setClientError("Client name cannot be empty");
                            return;
                          }

                          // DO NOT clear newClientName
                          setSelectedClient("add-new");
                          setShowNewClientInput(false);
                        }

                        if (e.key === "Escape") {
                          setShowNewClientInput(false);
                          setNewClientName("");
                          setSelectedClient("");
                          setClientError("");
                        }
                      }}
                      ref={clientRef}
                    />
                  )}
                  {clientError && (
                    <span className="formError">{clientError}</span>
                  )}
                  {errorObject.client && (
                    <span className="formError">{errorObject.client}</span>
                  )}
                </div>
              </div>
            </div>
            <div className="resident-card d-flex flex-column gap-2 mt-3 text-start">
              <h3 className="resident-card-header">Site Documents</h3>
              <FileUpload
                setFiles={setFiles}
                files={files}
                setError={setError}
                error={error}
                setShowValidation={setShowValidation}
                showValidation={showValidation}
                savedCompDocs={savedCompDocs}
                handleDeleteSaved={handelDeleteSavedCompDoc}
              />
            </div>
          </>
        )}
        {/* {activeTab === "Block" && blockData.length === 0 && (
          <div className="mt-3">
            Please enter the number of buildings in Site Information.
          </div>
        )} */}
        {activeTab === "Block" &&
          blockData.length > 0 &&
          blockData.map((block, index) => {
            return (
              <div
                key={index}
                className="resident-card d-flex flex-column gap-2 mt-3 text-start"
              >
                <div className="d-flex flex-row align-items-center justify-content-between">
                  <h3 className="resident-card-header">
                    Building - {index + 1}
                  </h3>
                  <span
                    style={{ fontSize: "1.5rem", cursor: "pointer" }}
                    aria-label="Remove Building"
                    title="Remove Building"
                    onClick={() => {
                      if (block.isSavedBlockData) {
                        setShowConfirmationPopup({
                          show: true,
                          headingText: "Delete Building Data",
                          infoText:
                            "Are you sure you want to delete this building data, please note the previously saved data for this building will also be deleted. Deleting building will mark all the existing active inspections as cancelled.",
                          cancelText: "Cancel",
                          submittext: "Delete",
                        });
                        setBlockToDelete(block);
                        setFloorNumberToDelete({
                          item: "blockData",
                          floor: block.blockId,
                          blockId: index,
                          index: index,
                        });
                      } else {
                        removeBlock(block?.blockId);
                      }
                    }}
                  >
                    {" "}
                    &times;
                  </span>
                </div>
                <div className="card-body-section">
                  <div className="form-group">
                    <label htmlFor="name">
                      Name <span style={{ color: "red" }}>*</span>
                    </label>
                    <input
                      ref={(el) => (inputRefs.block.current[block.id] = el)}
                      type="text"
                      className={
                        block.formErrors?.blockName ? "input-error" : ""
                      }
                      placeholder="Enter block name"
                      id={`name1`}
                      name="blockName"
                      value={block.blockName}
                      onChange={(e) => {
                        handleBlockDataChange(
                          index,
                          "blockName",
                          e.target.value,
                        );
                      }}
                    />

                    {block.formErrors?.blockName && (
                      <div className="formError">
                        {block.formErrors.blockName}
                      </div>
                    )}
                  </div>
                  {/* for building image code  */}
                  <div className="form-group">
                    <label htmlFor="contact1">Building Image</label>
                    {!block?.previewBuildingImage && (
                      <div
                        className={`d-flex justify-content-between customerFileBtn align-items-center gap-2 m-0 flex-row`}
                      >
                        <label
                          className="input-group-text mb-0"
                          htmlFor={`inputGroupFileBlock-${index}`}
                          style={{
                            fontSize: "15px",
                            lineHeight: 2,
                            color: " #081634",
                            backgroundColor: "white",
                            border: "1px solid #081634",
                            borderRadius: "5px",
                          }}
                        >
                          Choose File
                        </label>
                        <input
                          type="file"
                          id={`inputGroupFileBlock-${index}`}
                          accept=".jpg, .jpeg, .png, .gif, .pdf"
                          onChange={(e) =>
                            handleBlockDataChange(index, "buildingImage", e)
                          }
                          ref={setFileInputRefBuilding(index)}
                        />
                        <img
                          src={delicon}
                          alt="Delete"
                          onClick={() =>
                            block?.buildingImage &&
                            removeBuildingImage(index, block?.blockId)
                          }
                          style={{
                            width: "20px",
                            height: "20px",
                            cursor: block?.buildingImage
                              ? "pointer"
                              : "not-allowed",
                            marginLeft: "1rem",
                            opacity: block?.buildingImage ? 1 : 0.4,
                          }}
                        />
                      </div>
                    )}
                    {block?.previewBuildingImage && (
                      <div className="mt-2">
                        {block?.buildingImageType === "application/pdf" ? (
                          <div className="d-flex align-items-center flwx-row">
                            <p className="text-sm text-gray-600 mb-1">
                              Preview:{" "}
                              <a
                                href={block.previewBuildingImage}
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                {block?.buildingFileName || "View PDF"}
                              </a>
                            </p>
                            <i
                              className="fa-solid fa-xmark pointer ms-2"
                              style={{ cursor: "pointer" }}
                              onClick={() => {
                                setFloorNumberToDelete({
                                  item: "building",
                                  floor: block.blockId,
                                  blockId: index,
                                  index: index,
                                });
                                setShowConfirmationPopup({
                                  show: true,
                                  headingText: "Delete Building Image",
                                  infoText:
                                    "Are you sure you want to delete this building image?",
                                  cancelText: "Cancel",
                                  submittext: "Delete",
                                });
                              }}
                            ></i>
                          </div>
                        ) : (
                          <>
                            <div className="floorplan-item">
                              <img
                                height="150px"
                                width="150px"
                                src={block.previewBuildingImage}
                                alt="Building Image"
                                className="img-fluid"
                              />
                              <div className="floorplan-overlay">
                                <div className="floorplanbutton-group">
                                  <i
                                    className="fa-solid fa-xmark pointer"
                                    style={{ cursor: "pointer" }}
                                    onClick={() => {
                                      setFloorNumberToDelete({
                                        item: "building",
                                        floor: block.blockId,
                                        blockId: index,
                                        index: index,
                                      });
                                      setShowConfirmationPopup({
                                        show: true,
                                        headingText: "Delete Building Image",
                                        infoText:
                                          "Are you sure you want to delete this building image?",
                                        cancelText: "Cancel",
                                        submittext: "Delete",
                                      });
                                    }}
                                  ></i>
                                </div>
                              </div>
                            </div>
                          </>
                        )}
                      </div>
                    )}
                  </div>
                  <div className="form-group">
                    <label htmlFor="name">
                      Total Floors <span style={{ color: "red" }}>*</span>
                    </label>
                    <input
                      type="number"
                      className={
                        block.formErrors?.totalFloors ? "input-error" : ""
                      }
                      placeholder="Enter total floors"
                      id={`name1`}
                      name="totalFloors"
                      value={block.totalFloors}
                      onKeyDown={handleKeyDown}
                      onBlur={() => handleTotalFloorsBlur(index)}
                      onChange={(e) => {
                        handleBlockDataChange(
                          index,
                          "totalFloors",
                          e.target.value,
                        );
                      }}
                    />
                    {block.formErrors?.totalFloors && (
                      <div className="formError">
                        {block.formErrors.totalFloors}
                      </div>
                    )}
                  </div>
                </div>
                {block.floorArray.length > 0 &&
                  block.floorArray.map((floor, i) => {
                    return (
                      <div key={i} className="card-body-section">
                        <div className="form-group">
                          <label htmlFor="name">
                            Floor Number <span style={{ color: "red" }}>*</span>
                          </label>
                          <input
                            type="number"
                            placeholder="Enter total floors"
                            id={`name1`}
                            disabled
                            name="totalFloors"
                            value={floor.floor}
                            onKeyDown={handleKeyDown}
                            onChange={(e) => {
                              handleBlockDataChange(
                                index,
                                "totalFloors",
                                e.target.value,
                              );
                            }}
                          />
                        </div>
                        <div className="form-group">
                          <label htmlFor="contact1">
                            Floor Plan Image{" "}
                            {/* <span style={{ color: "red" }}>*</span> */}
                          </label>
                          {!floor.loadedImage && (
                            <div
                              className={`d-flex justify-content-between customerFileBtn align-items-center gap-2 m-0 flex-row`}
                            >
                              <label
                                className="input-group-text mb-0"
                                htmlFor={`inputGroupFile-${index}-${floor.floor}`}
                                style={{
                                  // height: "36px",
                                  fontSize: "15px",
                                  lineHeight: 2,
                                  color: " #081634",
                                  backgroundColor: "white",
                                  border: "1px solid #081634",
                                  borderRadius: "5px",
                                }}
                              >
                                Choose File
                              </label>
                              <input
                                type="file"
                                // className={
                                //   floor.floorError ? "input-error" : ""
                                // }
                                id={`inputGroupFile-${index}-${floor.floor}`}
                                accept=".jpg, .jpeg, .png, .gif, .pdf"
                                ref={setFileInputRef(index, floor.floor)}
                                onChange={(e) => {
                                  handleBlockFloorImageChange(
                                    index,
                                    floor.floor,
                                    e,
                                  );
                                }}
                              />
                              <img
                                src={delicon}
                                alt="Delete"
                                onClick={() =>
                                  removeFloorImage(index, floor.floor)
                                }
                                style={{
                                  width: "20px",
                                  height: "20px",
                                  // cursor: "pointer",
                                  // marginLeft: "1rem",
                                  cursor: floor.image
                                    ? "pointer"
                                    : "not-allowed",
                                  marginLeft: "1rem",
                                  opacity: floor.image ? 1 : 0.4,
                                }}
                              />
                            </div>
                          )}
                          {floor.loadedImage && (
                            <>
                              {floor.floorPdfUrl ? (
                                <div className="d-flex align-items-center flwx-row">
                                  <p className="text-sm text-gray-600 mb-1">
                                    Preview:{" "}
                                    <a
                                      href={floor.floorPdfUrl}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                    >
                                      {floor.floorPdfName || "View PDF"}
                                    </a>
                                  </p>
                                  <i
                                    className="fa-solid fa-xmark pointer ms-2"
                                    style={{ cursor: "pointer" }}
                                    onClick={() => {
                                      setFloorNumberToDelete({
                                        item: "floor",
                                        floor: floor.floor,
                                        blockId: floor.blockId,
                                        index: index,
                                      });
                                      setShowConfirmationPopup({
                                        show: true,
                                        headingText: "Delete Floor Image",
                                        infoText:
                                          "Are you sure you want to delete this floor image?",
                                        cancelText: "Cancel",
                                        submittext: "Delete",
                                      });
                                    }}
                                  ></i>
                                </div>
                              ) : (
                                <div className="floorplan-item">
                                  <img
                                    src={
                                      ImageProxyBaseUrl +
                                      encodeURIComponent(floor?.image)
                                    }
                                    alt="Background"
                                    className="img-fluid"
                                  />
                                  <div className="floorplan-overlay">
                                    <div className="floorplanbutton-group">
                                      <i
                                        className="fa-solid fa-xmark pointer"
                                        style={{ cursor: "pointer" }}
                                        onClick={() => {
                                          setFloorNumberToDelete({
                                            item: "floor",
                                            floor: floor.floor,
                                            blockId: floor.blockId,
                                            index: index,
                                          });
                                          setShowConfirmationPopup({
                                            show: true,
                                            headingText: "Delete Floor Image",
                                            infoText:
                                              "Are you sure you want to delete this floor image?",
                                            cancelText: "Cancel",
                                            submittext: "Delete",
                                          });
                                        }}
                                      ></i>
                                    </div>
                                  </div>
                                </div>
                              )}
                            </>
                          )}
                          {/* {floor.floorError && (
                            <div className="formError">{floor.floorError}</div>
                          )} */}
                        </div>
                      </div>
                    );
                  })}

                {/* <h3 className="resident-card-header mt-2">
                  Additional documents
                </h3> */}
                {/* <FileUpload
                  setFiles={(files) => {
                    handleBlockDataChange(index, "additionalDocsArr", files);
                  }}
                  files={block.additionalDocsArr}
                  setError={(err) => {
                    handleBlockDataChange(index, "fileError", err);
                  }}
                  error={block.fileError}
                  setShowValidation={(val) => {
                    handleBlockDataChange(index, "fileShowValidation", val);
                  }}
                  showValidation={block.fileShowValidation}
                  savedCompDocs={block.savedadditionalDocsArr}
                  handleDeleteSaved={(file) =>
                    handelDeleteSavedCompDocBlock(file, block)
                  }
                /> */}
              </div>
            );
          })}
        {activeTab === "Block" && (<>
          {errorObject.buildingRequired && (
            <div className="form-group"><span className="formError">
              {errorObject.buildingRequired}
            </span></div>
          )}
          <button
            type="button"
            className="btn btn-primary custom_toolbar_btn col-3 mx-2 mt-3"
            onClick={() => {
              AddBlock();
              setErrorObject((prevErrors) => ({
                ...prevErrors,
                buildingRequired: "",
              }));
            }}
          >
            <i className=" fa-solid fa-plus addBlock"></i> Add New Building
          </button>
          </>
        )}
        {/* {activeTab === "Block" && (
          <div className="mt-3">
            {errorObject.buildingRequired && (
            <div className="form-group"><span className="formError">
              {errorObject.buildingRequired}
            </span></div>
          )}
          </div>
        )} */}

        <div className="button-container align-items-center">
          <button
            type="submit"
            className="btn-primary  col-sm-5 col-md-2"
            // onClick={(e) => {

            //   if (!isClientFieldEnabled) {
            //     e.preventDefault();
            //     setIsClientFieldEnabled(true);
            //   } else {

            //     handleUpdateProperty(e);
            //   }
            // }}
            onClick={handleUpdateProperty}
          >
            {/* {isClientFieldEnabled ? "Update" : "Edit"} */}
            Update
          </button>
          <button
            type="button"
            className="btn-secondary  col-sm-5 col-md-2"
            onClick={() => {
              setRenderUpdateProperty(false);
            }}
          >
            Cancel
          </button>
          {validationFlag && (
            <div style={{ color: "red" }} className="me-auto">
              * Please fill all required fields
            </div>
          )}
        </div>
      </div>
      <LoadingComponent loading={loading} />
      <ConfirmationPopup
        show={showConfirmationPopup.show}
        headingText={showConfirmationPopup.headingText}
        infoText={showConfirmationPopup.infoText}
        cancelText={showConfirmationPopup.cancelText}
        submitText={showConfirmationPopup.submittext}
        onCancel={() => {
          setShowConfirmationPopup({
            ...showConfirmationPopup,
            show: false,
            headingText: "",
            infoText: "",
            cancelText: "",
            submittext: "",
          });
        }}
        onSubmit={() => {
          setShowConfirmationPopup({
            ...showConfirmationPopup,
            show: false,
            headingText: "",
            infoText: "",
            cancelText: "",
            submittext: "",
          });
          if (floorNumberToDelete.item === "building") {
            handleDeleteBuildingImage(
              floorNumberToDelete.floor,
              floorNumberToDelete.blockId,
            );
          } else if (floorNumberToDelete.item === "floor") {
            removeFloorImage(
              floorNumberToDelete.index,
              floorNumberToDelete.floor,
            );
            // handelDeleteSavedFloorImage(
            //   floorNumberToDelete.floor,
            //   floorNumberToDelete.blockId,
            // );
          } else if (floorNumberToDelete.item === "blockData") {
            handleDeleteBlockData(blockToDelete);
            removeBlock(blockToDelete.blockId);
          }
        }}
      />
    </>
  );
};
export default UpdateProperty;
